import React from 'react';
import { node, shape, string } from 'prop-types';
import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './errorMessage.module.css';
var ErrorMessage = React.forwardRef(function (props, ref) {
  var children = props.children;
  var classes = useStyle(defaultClasses, props.classes);
  return React.createElement("div", {
    className: classes.root,
    ref: ref
  }, React.createElement("span", {
    className: classes.errorMessage
  }, children));
});
export default ErrorMessage;
ErrorMessage.propTypes = {
  classes: shape({
    root: string,
    errorMessage: string
  }),
  children: node
};